import { gql, useQuery } from "@apollo/client";

const GetTeacherScoreQuery = gql`
  query getTeacherScore($teacherId: String!) {
    getTeacherScore(teacherId: $teacherId) {
      studentBayesianAvg
      coordinatorScore
      finalScore
    }
  }
`;

export type TeacherScore = {
  studentBayesianAvg: number;
  coordinatorScore: number | null;
  finalScore: number;
};

export function useTeacherScore(teacherId: string) {
  const { data, loading } = useQuery(GetTeacherScoreQuery, {
    variables: { teacherId },
    fetchPolicy: "cache-and-network",
  });

  return {
    score: (data?.getTeacherScore ?? null) as TeacherScore | null,
    loading,
  };
}
